import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentProject } from '@neptune/current-project-business-logic';
import { ShareModal } from '@neptune/project-ui';
import { isOnPremiseDeployment } from 'common/deploymentModes';
import { getCurrentOrganization } from 'state/selectors';

type ShareModalContainerProps = {
  isOpen: boolean;
  close: () => void;
};

export const ShareModalContainer: React.FC<ShareModalContainerProps> = ({ isOpen, close }) => {
  const project = useSelector(getCurrentProject);
  const organization = useSelector(getCurrentOrganization);

  const handleEmail = () => {
    window.open(
      'mailto:?body=Hey!%0D%0A' +
        'Here is a direct link to one thing I wanted to show you in Neptune:%0D%0A' +
        window.location.href +
        '&subject=I share a Neptune link with you',
      '__blank',
      'noopener, noreferrer',
    );
  };

  const handleTwitter = () => {
    window.open('https://twitter.com/intent/tweet', '__blank', 'noopener, noreferrer');
  };

  return (
    <ShareModal
      isOnPremiseDeployment={isOnPremiseDeployment()}
      link={window.location.href}
      projectPrivacy={project?.visibility}
      organizationName={organization?.name}
      organizationType={organization?.organizationType}
      isOpen={isOpen}
      onClose={close}
      onSendMail={handleEmail}
      onSendTwitter={handleTwitter}
    />
  );
};
